import React, { useState } from 'react';

import { ScreenHead } from '../../ui/screen-parts.js';
import { Chip, Field, Panel, Empty, useFlash, readForm } from '../../ui/kit.js';
import { useBuilding, RESIDENT, printDate } from '../../state/building.js';

import MoveBoxes from '../../media/images/modules/move-boxes.jpg';

const STATUS_TONE = { 'Pending': 'warn', 'Confirmed': 'ok', 'Approved': 'ok', 'Declined': 'alert' };

const SLOTS = ['9:00 AM – 12:00 PM', '1:00 PM – 4:00 PM', '4:00 PM – 7:00 PM'];

const RULES = [
    'Book the service elevator at least 72 hours ahead',
    'Moves Monday to Saturday only, never on holidays',
    'Movers carry a certificate of insurance naming the association',
    'Use the loading dock on NE 2nd Ave, not the main lobby',
    'Elevator padding goes up before the first load',
    'Refundable $500 damage deposit due at the front desk'
];

/* Move-In / Move-Out: the resident books a slot, management approves it. */
function MoveScreen() {
    const { moves, add } = useBuilding();
    const [flash, notify] = useFlash();
    const [done, setDone] = useState([]);
    const mine = moves.filter(m => m.unit === RESIDENT.unit);

    const submit = event => {
        const values = readForm(event, ['date']);
        if (!values) return notify('Pick a move date first.');
        if (!values.coi) return notify('The mover needs a certificate of insurance on file before we can book.');

        add('moves', {
            unit: RESIDENT.unit,
            kind: values.kind,
            date: printDate(values.date),
            slot: values.slot,
            padding: Boolean(values.padding),
            status: 'Pending'
        });
        notify(`${values.kind} requested for ${printDate(values.date)}. Management will confirm the elevator.`);
    };

    const toggle = rule => setDone(list => (list.includes(rule) ? list.filter(r => r !== rule) : [...list, rule]));

    return (
        <div className="screen-content">
            <ScreenHead eyebrow="Move-in / move-out" title="Schedule a move" />
            {flash}

            <div className="banner">
                <img src={MoveBoxes} alt="" />
                <p className="banner__caption">Book the service elevator and loading dock in one request.</p>
            </div>

            <div className="split">
                <Panel as="form" className="panel--accent" onSubmit={submit}>
                    <h4>Reserve the service elevator</h4>
                    <div className="form">
                        <Field label="Move type">
                            <select name="kind" className="form-control" defaultValue="Move-in">
                                {['Move-in', 'Move-out', 'Large delivery'].map(k => <option key={k}>{k}</option>)}
                            </select>
                        </Field>
                        <Field label="Date">
                            <input name="date" type="date" className="form-control" />
                        </Field>
                        <Field label="Time slot" wide>
                            <select name="slot" className="form-control" defaultValue={SLOTS[0]}>
                                {SLOTS.map(s => <option key={s}>{s}</option>)}
                            </select>
                        </Field>
                        <label className="field field--wide check">
                            <input type="checkbox" name="padding" defaultChecked style={{ width: 'auto' }} />
                            <span>Hang elevator padding for this move</span>
                        </label>
                        <label className="field field--wide check">
                            <input type="checkbox" name="coi" style={{ width: 'auto' }} />
                            <span>My mover's certificate of insurance has been sent to management</span>
                        </label>
                        <button type="submit" className="btn btn-primary">Request move</button>
                    </div>
                </Panel>

                <div className="stack">
                    <h4>Your moves</h4>
                    {mine.length === 0 ? <Empty>No moves booked for unit {RESIDENT.unit}.</Empty> : (
                        <ul className="rows">
                            {mine.map(m => (
                                <li className="row" key={m.id}>
                                    <div className="row__main">
                                        <span className="row__title">{m.kind}</span>
                                        <span className="row__meta">{m.date} · {m.slot}{m.padding ? ' · padding requested' : ''}</span>
                                    </div>
                                    <div className="row__end">
                                        <Chip tone={STATUS_TONE[m.status] || 'muted'}>{m.status}</Chip>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}

                    <h4>Move rules</h4>
                    <ul className="checks">
                        {RULES.map(rule => {
                            const on = done.includes(rule);
                            return (
                                <li key={rule}>
                                    <button type="button" className={`check${on ? ' check--on' : ''}`} aria-pressed={on} onClick={() => toggle(rule)}>
                                        <span className="check__box">{on ? '✓' : ''}</span>
                                        <span className="check__text">{rule}</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MoveScreen;
